import React from 'react';
import { WorkoutPlayer2 } from './player/WorkoutPlayer2';

interface WorkoutLauncherProps {
  workout: {
    id: string;
    name: string;
    exercises: Array<{
      name: string;
      duration: number;
      completed: boolean;
      description?: string;
      intensity?: string;
    }>;
    targetStrain?: number;
  };
  onClose: () => void;
}

export function WorkoutLauncher({ workout, onClose }: WorkoutLauncherProps) {
  return (
    <WorkoutPlayer2
      workout={workout}
      onClose={onClose}
    />
  );
}